import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";

export default function ExpenseRecordForm({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [title, setTitle] = useState("");
	const [amount, setAmount] = useState(0);
	const [description, setDescription] = useState("");
	const [dateRecordedString, setDateRecordedString] = useState("");


	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		setTitle("");
		setDescription('');
		setDateRecordedString('');
		setAmount(0);
	}

	async function create() {
		if(title.trim().length > 0) {
			if(Number(amount) > 0) {
				if(dateRecordedString.trim().length > 0) {
					setLoading(true);
					await callApi(
						'create-expense-record',
						{
							title,
							amount,
							dateRecordedString,
							description,
							schoolUuid: appContext.currentSchoolUuid,
						}
					).then(response => {
						if(response.status === 1) {
							appContext.tellMessage("Successful");
							resetForm()
						} else {
							appContext.tellError(response.msg)
						}
					})
					setLoading(false);
				} else {
					appContext.tellError("Invalid record date");
				}
			} else {
				appContext.tellError("Invalid amount");
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	

	useEffect(() => {
		if(data) {
			//..
		}
	}, [ data ])

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Expense Title</label>
					<input
						className="form-control"
						value={title}
						onChange={e => setTitle(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Expense Amount</label>
					<input
						className="form-control"
						value={amount}
						onChange={e => setAmount(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Record Date</label>
					<input
						className="form-control"
						type="date"
						value={dateRecordedString}
						onChange={e => setDateRecordedString(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Expense Description</label>
					<textarea
						className="form-control"
						value={description}
						onChange={e => setDescription(e.target.value)}
					/>
					<div className="form-text">Optional</div>
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							appContext.activateDialog({
								message: `Create new expense record, ${title}?`,
								onConfirm: create,
							})
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}